import { render, staticRenderFns } from "./authorize-instagram-btn.vue?vue&type=template&id=d7f5c436&scoped=true&"
import script from "./authorize-instagram-btn.vue?vue&type=script&lang=js&"
export * from "./authorize-instagram-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f5c436",
  null
  
)

export default component.exports